import { Chakra } from "@airhelp/react-ui-components";
import type { ComparisonCardsAdapterProps } from "modules/storyblok/adapters/ComparisonCards";
import ComparisonCard from "./ComparisonCard";

const { HStack, List, useBreakpointValue } = Chakra;

const ComparisonCardsDesktop = ({ content }: Pick<ComparisonCardsAdapterProps, "content">) => (
  <List>
    <HStack alignItems="stretch" spacing={8} my={1}>
      {content.map(({ _uid, heading, highlighted, tagText, content: cardContent }) => (
        <ComparisonCard
          key={_uid}
          heading={heading}
          highlighted={highlighted}
          tagText={tagText}
          content={cardContent}
          bgColor="greyscale.100"
        />
      ))}
    </HStack>
  </List>
);

const ComparisonCardsMobile = ({ content }: Pick<ComparisonCardsAdapterProps, "content">) => (
  <List display="flex" flexDir="column" gap={3} my={1}>
    {content.map(({ _uid, heading, highlighted, tagText, content: cardContent }) => (
      <ComparisonCard
        key={_uid}
        heading={heading}
        highlighted={highlighted}
        tagText={tagText}
        content={cardContent}
        bgColor="greyscale.100"
      />
    ))}
  </List>
);

const ComparisonCards = (props: Pick<ComparisonCardsAdapterProps, "content">) =>
  useBreakpointValue({ lg: true }) ? <ComparisonCardsDesktop {...props} /> : <ComparisonCardsMobile {...props} />;

export default ComparisonCards;
